import {
  StepItem,
  StepsProps
} from "../../../../../../shared/components/Steps";
import {
  SharedFileRequestContextType,
  SharedFileRequestStatus
} from "@wingspanhq/shared-files/dist/lib/interfaces/sharedFileRequest";
import { selectorIsSharedFileNotNoneContext } from "../../../../selectors/selectorIsSharedFileNotNoneContext";

const getStepsForCOIContext = (status: SharedFileRequestStatus): StepItem[] => {
  const allStepsCombinations: Record<
    SharedFileRequestStatus,
    StepsProps["steps"]
  > = {
    [SharedFileRequestStatus.Complete]: [
      {
        title: "Upload",
        status: "Complete"
      },
      {
        title: "Validation",
        status: "Complete"
      },
      {
        title: "Acceptance",
        status: "Complete"
      }
    ],
    [SharedFileRequestStatus.Processing]: [
      {
        title: "Upload",
        status: "Complete"
      },
      {
        title: "Validation",
        status: "Active"
      },
      {
        title: "Acceptance",
        status: "Pending"
      }
    ],
    [SharedFileRequestStatus.PendingUpload]: [
      {
        title: "Upload",
        status: "Active"
      },
      {
        title: "Validation",
        status: "Pending"
      },
      {
        title: "Acceptance",
        status: "Pending"
      }
    ],
    [SharedFileRequestStatus.PendingSubmission]: [
      {
        title: "Upload",
        status: "Complete"
      },
      {
        title: "Validation",
        status: "Warning"
      },
      {
        title: "Acceptance",
        status: "Active"
      }
    ],
    [SharedFileRequestStatus.Failed]: [
      {
        title: "Upload",
        status: "Complete"
      },
      {
        title: "Validation",
        status: "Failed"
      },
      {
        title: "Acceptance",
        status: "Pending"
      }
    ]
  };

  return allStepsCombinations[status];
};

const getStepsForGeneralContext = (
  status: SharedFileRequestStatus
): StepItem[] => {
  if (status === SharedFileRequestStatus.PendingUpload) {
    return [
      {
        title: "Upload",
        status: "Active"
      },
      {
        title: "Complete",
        status: "Pending"
      }
    ];
  } else if (status === SharedFileRequestStatus.Complete) {
    return [
      {
        title: "Upload",
        status: "Complete"
      },
      {
        title: "Complete",
        status: "Complete"
      }
    ];
  } else {
    return [
      {
        title: "Upload",
        status: "Complete"
      },
      {
        title: "Complete",
        status: "Pending"
      }
    ];
  }
};

export const getSharedFileProgressSteps = (
  status: SharedFileRequestStatus,
  contextType: SharedFileRequestContextType | undefined
): StepItem[] => {
  let steps: StepItem[];

  if (selectorIsSharedFileNotNoneContext(contextType)) {
    steps = getStepsForCOIContext(status);
  } else {
    steps = getStepsForGeneralContext(status);
  }

  return steps;
};
